import * as Helper from "../../../utils/Helper";
import ApiService from "../../ApiService";

const RegisterService = {
    register: (firstName, lastName, email, password, successCallback, failureCallback) => {
        var passwordHash = "";
        if (!Helper.isNullOrEmpty(password)) {
            let sha256 = require("crypto-js/sha256");
            passwordHash = sha256(password).toString();
        }

        ApiService.post("/account/register", { firstName: firstName, lastName: lastName, email: email, password: passwordHash }, successCallback, failureCallback);
    },
    registerPartner: (vo, successCallback, failureCallback) => {
        var password = vo.password;
        if (!Helper.isNullOrEmpty(password)) {
            let sha256 = require("crypto-js/sha256");
            vo.password = sha256(password).toString();
        }

        ApiService.post("/account/registerpartner", vo, successCallback, failureCallback);
    },
    getUserByEmail: (email, successCallback, failureCallback) => {
        ApiService.post("/account/getuserbyemail", { email: email }, successCallback, failureCallback);
    },

    getAllCountryCode: (successCallback, failureCallback) => {
        ApiService.post("/default/getcountrycode", null , successCallback, failureCallback);
    },

    sendCorpCode: (phone, isoCode, countryCode, templateType, uniqueCheck, successCallback, failureCallback) => {
        ApiService.post("/default/sendcorpreferralcode", { phone: phone, countryCode: countryCode, isoCode: isoCode, smsTemplateType: templateType, needUniquePhoneCheck: uniqueCheck }, successCallback, failureCallback);
    },

    sendSmsVerifyCode: (phone, isoCode, countryCode, templateType, uniqueCheck, successCallback, failureCallback) => {
        ApiService.post("/default/sendsmsverifycode", { phone: phone, countryCode: countryCode, isoCode: isoCode, smsTemplateType: templateType, needUniquePhoneCheck: uniqueCheck }, successCallback, failureCallback);
    },

    sendEmailVerifyCode: (email, successCallback, failureCallback) => {
        ApiService.post("/account/registerpartner/sendverifycode", { email: email }, successCallback, failureCallback);
    },

    activeTeacher: (vo, successCallback, failureCallback) => {
        var password = vo.password;
        if (!Helper.isNullOrEmpty(password)) {
            let sha256 = require("crypto-js/sha256");
            vo.password = sha256(password).toString();
        }

        ApiService.post("/account/activeTeacher", vo, successCallback, failureCallback);
    },
};

export default RegisterService;